module.exports = __webpack_public_path__ + "static/media/CallIcon.671670bc.svg";